import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/arkOne/capitalIcon.png'


const _withScopeId = n => (_pushScopeId("data-v-b8a03f10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "capital-distribution" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = ["alt"]
const _hoisted_4 = {
  key: 0,
  class: "no-data-wrapper"
}
const _hoisted_5 = {
  key: 1,
  class: "distribution-cards"
}
const _hoisted_6 = { class: "distribution-card" }
const _hoisted_7 = { class: "card-value" }
const _hoisted_8 = { class: "card-label" }
const _hoisted_9 = { class: "distribution-card" }
const _hoisted_10 = { class: "card-value" }
const _hoisted_11 = { class: "card-label" }
const _hoisted_12 = { class: "distribution-card" }
const _hoisted_13 = { class: "card-value" }
const _hoisted_14 = { class: "card-label" }
const _hoisted_15 = { class: "distribution-card" }
const _hoisted_16 = { class: "card-value" }
const _hoisted_17 = { class: "card-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nodata = _resolveComponent("Nodata")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.t('capitalDistribution.title')), 1),
    _createElementVNode("img", {
      class: "capital-icon",
      src: _imports_0,
      alt: _ctx.t('capitalDistribution.title') + '图标'
    }, null, 8, _hoisted_3),
    (!_ctx.hasData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_Nodata, {
            nodatadesc: _ctx.t('capitalDistribution.noData'),
            mode: "vertical"
          }, null, 8, ["nodatadesc"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.formatValue(_ctx.distribution.stocks)), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t('capitalDistribution.stocks')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatValue(_ctx.distribution.etf)), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t('capitalDistribution.etf')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formatValue(_ctx.distribution.cash)), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t('capitalDistribution.cash')), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.formatValue(_ctx.distribution.other)), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t('capitalDistribution.other')), 1)
          ])
        ]))
  ]))
}